module.exports = __webpack_public_path__ + "img/mail.dd8d9bef.svg";